import { render, staticRenderFns } from "./upload-thumb.vue?vue&type=template&id=4d1fb943"
import script from "./upload-thumb.vue?vue&type=script&lang=js"
export * from "./upload-thumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports